import React__default from 'react';
import { useProposalContext } from '../proposalContext.esm.js';
import t from '../../../services/translatorService.esm.js';

const AddProposal = props => {
  const {
    dispatch
  } = useProposalContext();
  const onAddProposal = () => {
    dispatch({
      type: 'SET_STEP',
      payload: 'selectClient'
    });
    dispatch({
      type: 'SET_SELECTED_PROPOSAL',
      payload: null
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "proposal-item proposal-item--add"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "font-semibold"
  }, t('proposals.newProposal')), /*#__PURE__*/React__default.createElement("button", {
    onClick: onAddProposal,
    className: "add-btn"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "ri-add-line"
  })));
};

export { AddProposal as default };
//# sourceMappingURL=AddProposal.esm.js.map
